import { render, staticRenderFns } from "./Performance.html?vue&type=template&id=22f1f988&scoped=true&"
import script from "./Performance.js?vue&type=script&lang=js&"
export * from "./Performance.js?vue&type=script&lang=js&"
import style0 from "./Performance.scss?vue&type=style&index=0&id=22f1f988&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f1f988",
  null
  
)

export default component.exports